const SHOWN_KEY = 'capio-engage-teaser-shown';
const DISMISSED_KEY = 'capio-engage-teaser-dismissed';

function readFlag(key: string): boolean {
  try {
    return sessionStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

function writeFlag(key: string): void {
  try {
    sessionStorage.setItem(key, '1');
  } catch {
    // sessionStorage may be blocked
  }
}

export function hasTeaserBeenShown(): boolean {
  return readFlag(SHOWN_KEY);
}

export function hasTeaserBeenDismissed(): boolean {
  return readFlag(DISMISSED_KEY);
}

export function markTeaserShown(): void {
  writeFlag(SHOWN_KEY);
}

export function markTeaserDismissed(): void {
  writeFlag(DISMISSED_KEY);
  writeFlag(SHOWN_KEY);
}
